export function initialize(appInstance) {
  // let persister = appInstance.lookup("service:persister")
}

export default {
  name: "persister",
  initialize: initialize,
  after: ["socket"],
}
